import React, { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useHistory } from "react-router";
import { AuthContext } from "../context/AuthContext";
import firebase from "firebase/app";
import getTourById from "../requests/getTourById";
import editTourById from "../requests/editTourById";

const TourEdit = () => {
  const history = useHistory();
  const { setUser } = useContext(AuthContext);
  const [ token, setToken ] = useState("");
  const [ tourFields, setTourFields ] = useState({
    name: "",
    artist: ""
  });

  const { tourId } = useParams();

  firebase.auth().onAuthStateChanged(function(firebaseUser) {
    if (firebaseUser) {
      setUser(firebaseUser);
      firebaseUser.getIdToken().then(token => {
        setToken(token);
        // console.log("JWT:", token);
      })
    } else {
      history.push("/login");
    }
  });

  useEffect(() => {
    if (token) {
      getTourById(token, tourId).then(response => {
        if (response.status === 200) {
          setTourFields(response.data[0]);
        }
      });
    }
  }, [token, tourId]);

  const handleUpdateTour = (event) => {
    event.preventDefault();
    if (token) {
      editTourById(token, tourId, tourFields)
      .then(response => {
        if (response.status === 200) {
          history.push(`/`);
        }
      })
      .catch(e => console.log(e));
    }
  };

  const handleFieldChange = (event) => {
    setTourFields((prev) => {
      return {
        ...prev,
        [event.target.name]: event.target.value,
      };
    });
  };

  if (tourFields.name) {

    return (
      <div className="container">
        <Link to="/" className="nav-link">All tours</Link>  
        <form onSubmit={handleUpdateTour}>
          <h3 className="form-heading">Edit tour</h3>

          <div>
          <label htmlFor="artist">Artist</label>
            <input 
              type="text"
              name="artist"
              id="artist"
              value={tourFields.artist}
              onChange={handleFieldChange}
            />
          </div>

          <div>
            <label htmlFor="name">Tour name</label>
            <input 
              type="text"
              name="name"
              id="name"
              value={tourFields.name}
              onChange={handleFieldChange}
            />
          </div>

          <button disabled={!tourFields.name || !tourFields.artist} className="form-button" type="submit">Edit tour</button>
        </form>
      </div>
    );

  } else {

    return (
      <div className="container">
        <div className="unauthorised-deletion">
          <h2 className="heading">Unauthorised</h2>
          <p>You appear not to be authorised to edit this tour.</p>
          <p>If you arrived here by clicking a link on the Tours page then something went wrong between leaving that page and arriving here. Perhaps <Link to="/">go back</Link> and try again.</p>
          <p>If you found your way here by some other means then you're wasting your time.</p>
          
        </div>
      </div>
    )
  }

  

};

export default TourEdit;